import React from 'react'
import { PropTypes } from 'prop-types'
import './style.scss'

const Label = ({ children, className, hint, htmlFor }) => (
    <>
        <label className={`labelStyle ${className}`} htmlFor={htmlFor}>
            <span className="labelTextStyle" id={`${htmlFor}LabelledBy`}>{children}</span>
            {hint && <span className="labelHintStyle" id={`${htmlFor}DescBy`}>{hint}</span>}
        </label>
    </>
)

Label.defaultProps = {
    children: '',
    className: '',
    hint: undefined,
    htmlFor: '',
}
Label.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.string,
    ]),
    className: PropTypes.string,
    hint: PropTypes.string,
    htmlFor: PropTypes.string,
}

export default Label
